/*
 * @Author: Teemo Ding
 * @Date: 2021-07-08 17:22:22
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-13 13:23:16
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelOrder/index.tsx
 */
import { getI18nFromGeneral } from '@/src/tools/tools';
import { Skeleton } from '@/src/components/Antd';
import NoPermission from '@/src/components/NoPermission';
import RouteBlock from '@/src/constrains/RouterBlock/RouterBlock';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import { SalesChannelModeAccessControlHOC } from 'src/constrains/SalesChannelModeAccessControl';
import { getSalesChannel } from '@/src/request/salesChannel/salesChannel';
import {
  request_orderData,
  save_orderData,
} from '@/src/request/salesChannel/setting/order';
import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
  EPermissionSource,
} from '@/src/types/common/resources';
import { Form, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { getTCs } from 'src/request/salesChannel/legal';
import {
  breadcrumbData,
  LimitationAppliesValues,
  OrderOptionsValues,
  OrderType,
} from './config';
// import { transformPriceObject, wrapPriceObject } from '@/src/tools/helper';
import MaximumPurchaseLimitation from './MaximumPurchaseLimitation';
import OrderIdFormat from './OrderIdFormat';
import OrderReturnOrRefund from './OrderReturnOrRefund';
// import TotalOrderAmount from './TotalOrderAmount';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const permissions = (uuid: string) => {
  const view_order_setting = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelSettings,
        subCategory: EnumSubCategory.ChannelOrder,
        operation: EnumOperation.view_order_setting,
        uuid,
      }),
    ],
  });
  const edit_order_setting = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelSettings,
        subCategory: EnumSubCategory.ChannelOrder,
        operation: EnumOperation.edit_order_setting,
        uuid,
      }),
    ],
  });

  return {
    view_order_setting,
    edit_order_setting,
  };
};

const SalesChannelOrder = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [form] = Form.useForm();
  const params: any = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [hasModified, setHasModified] = useState(false);
  const [salesChannelName, setSalesChannelName] = useState('');
  const [specificProducts, setSpecificProducts] = useState([]);
  const [orderData, setOrderData] = useState<any>({});
  const [tcsOptions, setTcsOptions] = useState([]);
  const [returnTacs, setReturnTacs] = useState([]);
  const [refundTacs, setRefundTacs] = useState([]);
  // const [currencyCode, setCurrencyCode] = useState('');

  const { uuid: salesChannelUuid } = params;
  const { view_order_setting, edit_order_setting } =
    permissions(salesChannelUuid);

  const handleSetRefundTacs = (data) => {
    setRefundTacs(data);
    setHasModified(true);
  };
  const handleSetReturnTacs = (data) => {
    setReturnTacs(data);
    setHasModified(true);
  };
  const handleSpecificProducts = (data) => {
    setSpecificProducts(data);
    setHasModified(true);
  };

  useEffect(() => {
    if (view_order_setting) {
      const termsAndConditionsReq = getTCs(salesChannelUuid);
      const salesChannelReq = getSalesChannel(salesChannelUuid);
      const orderReq = request_orderData(salesChannelUuid);
      Promise.all([termsAndConditionsReq, salesChannelReq, orderReq])
        .then((res: any) => {
          const termsAndConditions = res[0].summaryList || [];
          setTcsOptions(termsAndConditions);
          const salesChannelData = res[1].name || '';
          setSalesChannelName(salesChannelData);
          // const currencyCode = res[2].currencyCode;

          // // 扁平数据结构化
          // res[2].minTotalOrderAmountLocalPrices = wrapPriceObject(
          //   res[2].minTotalOrderAmountLocalPrices,
          //   'minTotalOrderAmount',
          // );

          // res[2].maxTotalOrderAmountLocalPrices = wrapPriceObject(
          //   res[2].maxTotalOrderAmountLocalPrices,
          //   'maxTotalOrderAmount',
          // );

          //格式化后端返回数据适配前端组件
          const specificProductsData = (res[2].specificProducts || []).map(
            (item) => ({
              ...item,
              productName: item.name,
              uuid: item.salesChannelProductUuid,
            }),
          );
          const returnTacsData = (res[2].returnTacs || []).map((item) => ({
            ...item,
            uuid: item.salesChannelTermsConditionUuid,
            setAgreementAsRequired: item.agreenmentRequired,
          }));
          const refundTacsData = (res[2].refundTacs || []).map((item) => ({
            ...item,
            uuid: item.salesChannelTermsConditionUuid,
            setAgreementAsRequired: item.agreenmentRequired,
          }));
          setOrderData(res[2] || []);
          setSpecificProducts(specificProductsData);
          setReturnTacs(returnTacsData);
          setRefundTacs(refundTacsData);
          // setCurrencyCode(currencyCode);
        })
        .then(() => setLoading(false));
    }
  }, []);

  const child = [
    {
      child: <OrderIdFormat disableEdit={!edit_order_setting} />,
    },
    {
      child: (
        <MaximumPurchaseLimitation
          specificProducts={specificProducts}
          setSpecificProducts={handleSpecificProducts}
          disableEdit={!edit_order_setting}
        />
      ),
    },
    // {
    //   child: (
    //     <TotalOrderAmount
    //       currencyCode={currencyCode}
    //       disableEdit={!edit_order_setting}
    //     />
    //   ),
    // },
    {
      child: (
        <OrderReturnOrRefund
          type={OrderType.Return}
          salesChannelUuid={salesChannelUuid}
          tcsOptions={tcsOptions}
          tacs={returnTacs}
          tacsOnChange={handleSetReturnTacs}
          disableEdit={!edit_order_setting}
        />
      ),
    },
    {
      child: (
        <OrderReturnOrRefund
          type={OrderType.Refund}
          salesChannelUuid={salesChannelUuid}
          tcsOptions={tcsOptions}
          tacs={refundTacs}
          tacsOnChange={handleSetRefundTacs}
          disableEdit={!edit_order_setting}
        />
      ),
    },
  ];

  const onFinish = (values) => {
    // //嵌套结构对象数据扁平化
    // const transformedMin = transformPriceObject(
    //   values.minTotalOrderAmountLocalPrices as Record<
    //     string,
    //     { minTotalOrderAmount: number }
    //   >,
    //   'minTotalOrderAmount',
    // );

    // const transformedMax = transformPriceObject(
    //   values.maxTotalOrderAmountLocalPrices as Record<
    //     string,
    //     { maxTotalOrderAmount: number }
    //   >,
    //   'maxTotalOrderAmount',
    // );

    const orderFormData = {
      ...values,
      specificProducts,
      returnTacs,
      refundTacs,
      // minTotalOrderAmountLocalPrices: transformedMin,
      // maxTotalOrderAmountLocalPrices: transformedMax,
    };
    save_orderData(salesChannelUuid, orderFormData).then((data) => {
      message.success(getI18n('general.savesuccess'));
      setHasModified(false);
    });
  };
  const goBackToList = () => {
    history.push({
      pathname: `/salesChannel/settings/${salesChannelUuid}`,
    });
  };

  const topLeft = (
    <TopLeft
      goBack={goBackToList}
      breadcrumbData={breadcrumbData(salesChannelName, salesChannelUuid, {
        getI18n,
      })}
    />
  );

  const topRight = (
    <TopRight
      onDiscard={goBackToList}
      onSubmit={() => {
        form.submit();
      }}
      onSaveDisable={!hasModified || !edit_order_setting}
    />
  );
  return view_order_setting ? (
    <Skeleton loading={loading} active>
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18nFromGeneral('general.commonHeader.discard_text')}
        active={hasModified}
        title={getI18nFromGeneral('general.commonHeader.discard_header')}
        content={getI18nFromGeneral('general.commonHeader.discard_content')}
      />
      <Form
        name='invoice'
        form={form}
        onFinish={onFinish}
        onValuesChange={() => {
          setHasModified(true);
        }}
        initialValues={{
          ...orderData,
          // minTotalOrderAmountLocalPrices:
          //   orderData?.minTotalOrderAmountLocalPrices || {},
          // maxTotalOrderAmountLocalPrices:
          //   orderData?.maxTotalOrderAmountLocalPrices || {},
          appliesTo: orderData?.appliesTo || LimitationAppliesValues.EACH_ORDER,
          numOfDaysForRefund: orderData?.numOfDaysForRefund || 7,
          numOfDaysForReturn: orderData?.numOfDaysForReturn || 7,
          maxNumPerProduct: orderData?.maxNumPerProduct || 1,
          orderRefundOption:
            orderData?.orderRefundOption || OrderOptionsValues.AFTER_PURCHASED,
          orderReturnOption:
            orderData?.orderReturnOption || OrderOptionsValues.AFTER_PURCHASED,
        }}>
        <Layout elements={child} topLeft={topLeft} topRight={topRight}></Layout>
      </Form>
    </Skeleton>
  ) : (
    <NoPermission />
  );
};

export default SalesChannelModeAccessControlHOC(SalesChannelOrder);
